'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    CREATE_SUBJECT_REQUEST: 'CREATE_SUBJECT_REQUEST',
    CREATE_SUBJECT_SUCCEEDED: 'CREATE_SUBJECT_SUCCEEDED',
    CREATE_SUBJECT_FAILED: 'CREATE_SUBJECT_FAILED',
    DELETE_SUBJECT_REQUEST: 'DELETE_SUBJECT_REQUEST',
    DELETE_SUBJECT_SUCCEEDED: 'DELETE_SUBJECT_SUCCEEDED',
    DELETE_SUBJECT_FAILED: 'DELETE_SUBJECT_FAILED',
    FETCH_SUBJECTS_REQUEST: 'FETCH_SUBJECTS_REQUEST',
    FETCH_SUBJECTS_SUCCEEDED: 'FETCH_SUBJECTS_SUCCEEDED',
    FETCH_SUBJECTS_FAILED: 'FETCH_SUBJECTS_FAILED',
    FETCH_SUBJECT_REQUEST: 'FETCH_SUBJECT_REQUEST',
    FETCH_SUBJECT_SUCCEEDED: 'FETCH_SUBJECT_SUCCEEDED',
    FETCH_SUBJECT_FAILED: 'FETCH_SUBJECT_FAILED',
    EDIT_SUBJECT_REQUEST: 'EDIT_SUBJECT_REQUEST',
    EDIT_SUBJECT_SUCCEEDED: 'EDIT_SUBJECT_SUCCEEDED',
    EDIT_SUBJECT_FAILED: 'EDIT_SUBJECT_FAILED',
    EDIT_SUBJECT_CANCELED: 'EDIT_SUBJECT_CANCELED',
    CHANGE_FILTER: 'CHANGE_FILTER',
    APPLY_FILTER_ERROR: 'APPLY_FILTER_ERROR',
    CLEAR_SUBJECTS_FILTER: 'CLEAR_SUBJECTS_FILTER'
};

function fetchSubjectsRequest(filter) {
    return {
        type: actionTypes.FETCH_SUBJECTS_REQUEST,
        filter: filter
    };
}

function fetchSubjectsSucceeded(subjects, filter) {
    return {
        type: actionTypes.FETCH_SUBJECTS_SUCCEEDED,
        subjects: subjects,
        filter: filter
    };
}

function fetchSubjectsFailed(message) {
    return {
        type: actionTypes.FETCH_SUBJECTS_FAILED,
        message: message
    };
}

function fetchSubjectRequest(subjectId) {
    return {
        type: actionTypes.FETCH_SUBJECT_REQUEST,
        subjectId: subjectId
    };
}

function fetchSubjectSucceeded(subject) {
    return {
        type: actionTypes.FETCH_SUBJECT_SUCCEEDED,
        subject: subject
    };
}

function fetchSubjectFailed() {
    return {
        type: actionTypes.FETCH_SUBJECT_FAILED
    };
}

function editSubjectRequest(subjectId, changes, redirect) {
    return {
        type: actionTypes.EDIT_SUBJECT_REQUEST,
        subjectId: subjectId,
        changes: changes,
        redirect: redirect
    };
}

function editSubjectSucceeded() {
    return {
        type: actionTypes.EDIT_SUBJECT_SUCCEEDED
    };
}

function editSubjectFailed() {
    return {
        type: actionTypes.EDIT_SUBJECT_FAILED
    };
}

function editSubjectCanceled() {
    return {
        type: actionTypes.EDIT_SUBJECT_CANCELED
    };
}

function createSubjectRequest(subject, redirect) {
    return {
        type: actionTypes.CREATE_SUBJECT_REQUEST,
        subject: subject,
        redirect: redirect
    };
}

function createSubjectSucceeded() {
    return {
        type: actionTypes.CREATE_SUBJECT_SUCCEEDED
    };
}

function createSubjectFailed() {
    return {
        type: actionTypes.CREATE_SUBJECT_FAILED
    };
}

function deleteSubjectRequest(subjectId, filter) {
    return {
        type: actionTypes.DELETE_SUBJECT_REQUEST,
        subjectId: subjectId,
        filter: filter
    };
}

function deleteSubjectSucceeded() {
    return {
        type: actionTypes.DELETE_SUBJECT_SUCCEEDED
    };
}

function deleteSubjectFailed(error) {
    return {
        type: actionTypes.DELETE_SUBJECT_FAILED,
        error: error
    };
}

function changeFilter(key, value) {
    return {
        type: actionTypes.CHANGE_FILTER,
        key: key,
        value: value
    };
}

function clearSubjectsFilter() {
    return {
        type: actionTypes.CLEAR_SUBJECTS_FILTER
    };
}

var actionCreators = {
    createSubjectRequest: createSubjectRequest,
    createSubjectSucceeded: createSubjectSucceeded,
    createSubjectFailed: createSubjectFailed,
    deleteSubjectRequest: deleteSubjectRequest,
    deleteSubjectSucceeded: deleteSubjectSucceeded,
    deleteSubjectFailed: deleteSubjectFailed,
    fetchSubjectsRequest: fetchSubjectsRequest,
    fetchSubjectsSucceeded: fetchSubjectsSucceeded,
    fetchSubjectsFailed: fetchSubjectsFailed,
    fetchSubjectRequest: fetchSubjectRequest,
    fetchSubjectSucceeded: fetchSubjectSucceeded,
    fetchSubjectFailed: fetchSubjectFailed,
    editSubjectRequest: editSubjectRequest,
    editSubjectSucceeded: editSubjectSucceeded,
    editSubjectFailed: editSubjectFailed,
    editSubjectCanceled: editSubjectCanceled,
    changeFilter: changeFilter,
    clearSubjectsFilter: clearSubjectsFilter
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/subjects.js
// module id = 223
// module chunks = 0